<template>
  <div>
    <div
      v-if="!this.report"
      style="
        display: flex;
        justify-content: center;
        width: 100%;
        height: 500px;
        align-items: center;
      "
    >
      <b-spinner
        class="my-5"
        variant="primary"
        :label="this.$t('Spinning')"
      ></b-spinner>
    </div>
    <section id="historyContainer" style="height: 800px; margin-bottom: 35px" />
  </div>
</template>

<script>
import * as pbi from "powerbi-client";
import { mapActions, mapGetters } from "vuex";

export default {
  layout: "customer",
  data() {
    return {
      report: null,
      rid: null,
    };
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle"]),
    ...mapActions("powerBi", ["getPowerBiConfig", "fetchPowerBiApi"]),
  },
  computed: {
    ...mapGetters("powerBi", ["getReportData", "getPowerBiReportID"]),
    ...mapGetters("authentication", ["selectedUser"]),
  },

  async created() {
    await this.getPowerBiConfig();
    this.setPageTitle(this.$t("History Reports"));
    try {
      this.rid = this.getPowerBiReportID.rids.find(
        (report) => report.id === "history"
      ).powerbiid;

      await this.fetchPowerBiApi({
        rid: this.rid,
        uuid: this.selectedUser.uuid || null,
      });
    } catch (e) {
      console.log(e);
    } finally {
      this.report = this.getReportData.authentication;
      const permissions = pbi.models.Permissions.All;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      const customerID = this.report.uuid || this.selectedUser.uuid;

      const filt = {
        $schema: "http://powerbi.com/product/schema#advanced",
        operator: "In",
        values: [customerID],
      };
      const config = {
        type: "report",
        tokenType: 1,
        accessToken: this.report.token,
        embedUrl: this.report.embedUrl,
        id: this.rid,
        permissions: permissions,
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: false,
        },
        filter: [filt],
      };
      const dashboardContainer = document.getElementById("historyContainer");
      const dashboard = powerbi.embed(dashboardContainer, config);
      dashboard.off("loaded");
      dashboard.off("rendered");
      dashboard.on("error", function () {
        this.dashboard.off("error");
      });
    }
  },
};
</script>
<style lang="scss">
iframe {
  border: none !important;
}
</style>
<route>
{
  "name": "History Reports",
  "meta": {
    "authorize" : [1, 3, 4]
  }
}
</route>
